<template>
  <div class="flex flex-wrap col-12 relative p3 scrollable">
    <DetailedBreadcrumb class="p2 transparent" override-style :start-from="0" />
    <div class="flex col-12 p2 white-bg mb3 lighter-elevate">
      Retrouvez ici tous vos achats. Sélectionnez une commande pour consultez le détail.
    </div>

    <HistoryItem v-for="order in orders" :key="order.uuid" :order="order" :site-name="siteInfo.site_settings && siteInfo.site_settings.text_logo_name ? siteInfo.site_settings.text_logo_name : siteInfo.name" />

    <p v-if="!orders && orders.items.length === 0" class="h5n bold center warning m0">
      Vous n'avez pas de commande.
    </p>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
// import { isInImpersonateModeNotification } from '@/mixins/utils';
import HistoryItem from '../history/HistoryItem';
import DetailedBreadcrumb from '../common/DetailedBreadcrumb.vue';

export default {
  components: { HistoryItem, DetailedBreadcrumb },
  setup () {
    const store = useStore();
    const orders = ref((store.state.user.orders || []).filter(o => o.site_workspace === store.state.siteInfo.workspace && o.isPaid));

    const { siteInfo } = store.state;

    return {
      orders,
      siteInfo
    };
  }
};
</script>
